export default "__VITE_ASSET__BGW8zbL0__"